<template>
    <observaciones :listPath="listPath" :createPath="createPath" :editPath="editPath" @observacionCreada="$emit('observacionCreada')"
      ref="observaciones" :canEdit="canEdit" payloadId="pago" :id="pagoId" :canAdd="canAdd"/>
</template>

<script>
import Observaciones from './Observaciones'

export default {
  components: {
    Observaciones
  },
  props: {
    pagoId: [Number, String],
    canAdd: {
      type: Boolean,
      default: true
    },
    canEdit: Boolean
  },

  data () {
    return {
      observacionText: '',
      editable: true,
      editing: false,
      listPath: `pago/${this.pagoId}/observaciones`,
      createPath: `pago/observacion/${this.pagoId}/new`,
      editPath: 'pago/observacion'
    }
  }
}
</script>
